import React, { useRef } from 'react'
import '../../Styles/Technology.scss'
import logo1 from '../../Assests/Technology/logo1.png'
import logo2 from '../../Assests/Technology/logo2.png'
import logo3 from '../../Assests/Technology/logo3.png'
import logo4 from '../../Assests/Technology/logo4.png'
import logodeslogo1 from '../../Assests/Technology/des_logo1.png'
import logodeslogo2 from '../../Assests/Technology/des_logo2.jpg'
import logodeslogo3 from '../../Assests/Technology/des_logo3.jpg'

const Technology = () => {
    const teamSectionRef = useRef(null);
    const isMobile = window.innerWidth <= 768;
    const scrollToSection = () => {
        if (teamSectionRef.current) {
            teamSectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
        <div className='mt-5 pt-4 technology'>
            <div className='py-5 team-discover-story-technology w-100'>
                <div className='text-center fw-bold team-discover-story-text ' style={{ color: "#2D143D" }}>
                    <div>Technology</div>
                    {/* <div>Behind Our Team</div> */}
                </div>
                <div className='text-center team-discover-sub my-3'>
                    <div>
                        Advanced infrastructure and state-of-the-art technologies that makes
                    </div>
                    <div>us the forefront of the multiomics research.</div>

                    {/* Button container */}
                    <div
                        className='d-flex justify-content-center align-items-center mt-3'
                    // style={{ width: "100%" }}
                    >
                        <div
                            className=' d-flex justify-content-center  align-items-center  primary-btn ms-1 py-2 px-2 contact-us fw-bold read-btn'
                            // style={{ width: "12%" }}
                            onClick={scrollToSection}
                        >
                            <div >Read</div>
                            <span className="material-symbols-outlined ms-1  arrow-downRead">arrow_downward</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='my-5 text-center tech-sub' ref={teamSectionRef}>
                <div>A Multiomics company that offers comprehensive solutions for genomic, </div>
                <div>transcriptomics, metagenomic, metabolomic, lipidomic, and proteomic research</div>
            </div>
            <div className='hr-radius-border'></div>
            <div className='bg-color-tech p-2 text-center'>
                <div className='PARTNERS-size mt-2'>OUR PARTNERS</div>
                <div className='images-patners '>
                    <div>
                        <img className='' src={logo1} ></img>
                        <img className='p-2' src={logo2} ></img>
                    </div>
                    <div> <img className='p-4' src={logo3} ></img>
                        <img className='p-4' src={logo4} ></img>
                    </div>
                </div>
            </div>
            <div className='hr-radius-border'></div>
            <div className='w-75 m-auto my-4 text-justify my-5'>
                At Vizzhy, we are committed to providing high-quality results to our  clients by utilizing state-of-the-art technology and expertise. We have a wide range of instruments that cover all aspects of multiomics  research, from NGS sequencing to protein analysis. Our multiomics  approach enables us to provide a comprehensive understanding of  biological systems, which can lead to breakthroughs in various fields  such as drug discovery and personalized medicine. Contact us today to  learn more about our technology and how we can help with your research  needs.
            </div>

            <div className={`disply-flex-inmages row my-4 mt-5 ${isMobile ? "isMobile-tech-direction" : ""}`}>
                <div className='col-md-6 py-3 px-5'>
                    <div className='des-font-size'>Next Generation</div>
                    <div className='des-font-size'>Sequencing</div>
                    <div className='mt-2'>Our NGS technology is based on Illumina technology, which allows us to  sequence DNA and RNA with high accuracy and sensitivity. One of the key  devices used by Vizzhy is the Novaseq 6000 sequencing system. This  powerful sequencer can generate massive amounts of data quickly and  accurately, making it ideal for high-throughput sequencing projects.</div>
                </div>
                <div className='col-md-6 p-0 m-auto d-flex'>
                    <img className='imges-des-size' src={logodeslogo1}></img>
                </div>
            </div>
            <div className={`disply-flex-inmages my-4 row`}>
                <div className='col-md-6 p-0 m-auto d-flex'>
                    <img className='imges-des-size' src={logodeslogo2}></img>
                </div>
                <div className='col-md-6 py-3 px-5'>
                    <div className='des-font-size'>Mass Spectrometry</div>
                    <div className='mt-2'>Our mass spectrometry  technology enables us to analyze small molecules and proteins with high  precision and sensitivity. We utilize various techniques such as  LC-MS/MS to provide comprehensive metabolomic, lipidomic and proteomic  analysis.</div>

                    <div className='mt-4'>Vizzhy conducting high-resolution analysis of proteins and small molecules via Orbitrap Exploris 240 mass spectrometer and Vanquish UHPLC systems. The Lipidsearch software and Compound Discoverer software are used for the  analysis of lipidomics and metabolomics data.</div>
                </div>

            </div>
            <div className={`disply-flex-inmages my-4 mb-5 row ${isMobile ? "isMobile-tech-direction" : ""}`}>
                <div className='col-md-6 py-3 px-5'>
                    <div className='des-font-size'>Bioinformatics</div>
                    <div className='mt-2'>At Vizzhy, we understand  that the data generated from multiomics research can be overwhelming.  That's why we have a dedicated team of bioinformaticians and data  analysts who are experts in handling and analyzing large datasets. We  use various software and tools such as R, Python, Matlab, GATK,  bcl2fastq, BWA, BOWTIE2, SAMtools, VCFtools, Cutadapt, STAR, Metaphlan3, Kraken, Krona, Kallisto, Multiqc to provide accurate, comprehensive,  and efficient data analysis to our clients.</div>

                    <div className='mt-4'>The lab also uses the Dragen Bio-IT  platform for bioinformatics analysis of the sequencing data, which is a  highly efficient and accurate tool for identifying genomic variants, and transcriptomic analysis.</div>
                </div>
                <div className='col-md-6 p-0 m-auto d-flex'>
                    <img className='imges-des-size' src={logodeslogo3}></img>
                </div>
            </div>
        </div>
    )
}

export default Technology
